/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('DOMContentLoaded', () => {

    const vatNumberRequiredWhenInvoice = () => {
        
        document.body.addEventListener('change', (e) => {
            
            const vatInput = document.querySelector('#vat_number');

            if (e.target.getAttribute('id') == 'want_invoice') {
                if (vatInput) {
                    if (e.target.checked) {
                        vatInput.removeAttribute("disabled", "");
                    } else {
                        vatInput.setAttribute("disabled", "");
                        vatInput.classList.remove('-required-error');
                    }
                }
            }

        });

    };

    const validateVatInputOnType = () => {
        
        document.body.addEventListener('input', (e) => {
            
            if (e.target.getAttribute('id') == 'var_number') {
                if (e.target.value === "") {
                    e.target.classList.add('-required-error');
                } else {
                    e.target.classList.remove('-required-error');
                }   
            }

        });
        
    };

    const preventCheckoutIfNoNIP = () => {

        document.body.addEventListener("submit", (e) => {
            
            if (e.target.getAttribute("action") === "/checkout" || e.target.getAttribute("action") === "/cart") {
                
                const invoiceInput = document.querySelector('#want_invoice');
                const vatInput = document.querySelector('#vat_number');
                const vatInputError = document.querySelector('.js-vat-input-error');
                
                if (vatInput && invoiceInput && invoiceInput.checked) {
                    const formatErrorText = vatInput.getAttribute('data-format-error');
                    const lengthErrorText = vatInput.getAttribute('data-length-error');
                    const regex = /^[0-9]*$/;
                    if (!regex.test(vatInput.value)) {
                        e.preventDefault();
                        e.stopPropagation();
                        vatInputError.innerHTML = formatErrorText;
                        vatInput.classList.add('-validation-error');
                        return false;
                    } else {
                        if (vatInput.value.length != 10) {
                            e.preventDefault();
                            e.stopPropagation();
                            vatInputError.innerHTML = lengthErrorText;
                            vatInput.classList.add('-validation-error');
                            return false;
                        }
                    }
                }

            }

        });

    };


     const fixedProductForm = () => {
       const form = document.querySelector('.ProductForm');
       if(form) {
         window.addEventListener('scroll', function() {
          const formPosition = form.getBoundingClientRect().top;
           const greenBar = document.querySelector('#shopify-section-announcement');
           const header = document.querySelector('.shopify-section--header');
            if (formPosition <= 0) {
              form.classList.add('--fixed');
              header.classList.add('--fixToTop');
              greenBar.classList.add('--unfix');
            } 
        });
      }
    };


  
    fixedProductForm();
    vatNumberRequiredWhenInvoice();
    validateVatInputOnType();
    preventCheckoutIfNoNIP();
});